export type AlcanceSesion = "todos" | "sucursal" | "propia";

export interface SesionContexto {
  alcance: AlcanceSesion;
  usuarioId: number | null;
  permisos: string[];
  sessionId: string | null;
}

const determinarAlcance = (permisos: string[]): AlcanceSesion => {
  if (permisos.includes("usuarios.cerrar-sesion")) {
    return "todos";
  }
  if (permisos.includes("usuarios.ver")) {
    return "todos";
  }
  if (permisos.includes("usuarios.ver-activos")) {
    return "sucursal";
  }
  return "propia";
};

export const obtenerSesionContexto = (): SesionContexto => {
  if (typeof window === "undefined") {
    return { alcance: "propia", usuarioId: null, permisos: [], sessionId: null };
  }
  const bruto = sessionStorage.getItem("authUser");
  if (!bruto) {
    return { alcance: "propia", usuarioId: null, permisos: [], sessionId: null };
  }
  try {
    const data = JSON.parse(bruto);
    const permisos = Array.isArray(data?.usuario?.permisos)
      ? data.usuario.permisos
      : [];
    const usuarioId =
      typeof data?.usuario?.id === "number" ? data.usuario.id : null;
    const sessionId =
      typeof data?.sessionId === "string" ? data.sessionId : null;
    return {
      alcance: determinarAlcance(permisos),
      usuarioId,
      permisos,
      sessionId,
    };
  } catch {
    return { alcance: "propia", usuarioId: null, permisos: [], sessionId: null };
  }
};
